import React from "react";



function Refund_policy() {
  return (
    <div className="refund-container">
      <div className="refund-card">

        <h1 className="refund-title">Cancellation/Refund Policy</h1>

        <h6 className="refund-heading">Product Return Policy</h6>

        <p className="refund-text">
          In case of any dissatisfaction, manufacturing or packaging defect,
          customers/Distributors can return/exchange the product. The
          customers/Distributors must contact the Distributor/Company from whom
          they had purchased the same, within 30 days from the date of
          purchase. They have to provide a reason and return the said products.
          In case the customer returns the product, it is the distributor's
          obligation to satisfy the customer’s need for money refund or
          replacements of products.
        </p>

        <p className="refund-text">
          The Distributor can then return these products, with original Invoice
          to the Company. The Company will replace these products free of cost
          or if the distributor does not want the same products, the Company
          will give a cash voucher of the same amount, which can be used by the
          Distributor for purchasing products of their choice.
        </p>
        <ul className="refund-list">
            <li>Product Return Form</li>
          <li>Reason for return</li>
          <li>Copy of Invoice</li>
          <li>Products to be returned</li>
        </ul>

        <h6 className="refund-heading mt-4">Buy Back Policy</h6>

        <p className="refund-text">
          The Company provides a Buy Back Policy to the distributor who wishes
          to resign from his/her distributorship and return any Airdeal India
          products that are in good condition, useable, resaleable,
          restock-able, unopened, unaltered and must have a shelf life of at
          least four months.
        </p>

        <p className="refund-text">
          If the Distributor resigns within 30 days from the purchase of the
          products, Airdeal India shall provide a full refund for the products
          to the Distributor.
        </p>

        <p className="refund-text">
          If the Distributor resigns from his/her distributorship after the
          expiry of 30 days from the date of purchase of products from Airdeal
          India, the amount refunded will be equal to distributor cost of the
          products being returned, less total bonus paid out by the Company on
          the original purchase, less 10% service charge.
        </p>

        <p className="refund-text">
          The Buy Back policy is designed to impose upon the sponsor and the
          Company the obligation to ensure that the distributor is buying
          products wisely.
        </p>

        <h6 className="refund-heading">Cancellation</h6>

        <p className="refund-text">
          For Cancellation of confirmed/placed order please Contact Us on our
          helpline no : +91-9466045244
        </p>

        <p className="refund-text">
          or write to us at info@airdealindia.com
        </p>

        <div className="refund-note">
          <span className="text-bold">Please Note:</span> Product Return Policy is NOT valid on items if
          opened/Demaged.
        </div>

      </div>
    </div>
  );
}


export default Refund_policy;
